// worker.thunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions } from '../actions/worker.action';
import { workerApi } from '../apis/worker.api';
import {
  ReqFetchWorkers,
  ResWorkerDetail,
  ResWorkers,
  ResWorkerSafetyHistories
} from '../model/worker.model';
import qs from 'qs';
import { RootState } from 'modules/rootReducer';

/**
 * 어드민,관리자 같이 조회 (작업자 리스트)
 */
export const getWorkers = createAsyncThunk<ResWorkers, void, { state: RootState }>(
  actions.GET_WORKERS,
  async (_, { getState, fulfillWithValue, rejectWithValue }) => {
    try {
      let request = getState().worker.fetchWorkersRequest;
      if (request.company == 'ALL') {
        request = { ...request, company: '' };
      }

      const query = qs.stringify(request);

      const response = await workerApi.getWorkers(query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * worker / admin 같이 목록 조회
 */
export const getWorkersAdmins = createAsyncThunk<ResWorkers, ReqFetchWorkers>(
  actions.GET_WORKERS_ADMINS,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const query = qs.stringify(data);
      const response = await workerApi.getWorkersAdmins(query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * worker / admin 같이 목록 조회 by safetyId
 */
export const getWorkersBySafetyId = createAsyncThunk<ResWorkers, string, { state: RootState }>(
  actions.GET_WORKERS_BY_SAFETY_ID,
  async (safetyId, { getState, fulfillWithValue, rejectWithValue }) => {
    try {
      const request = getState().worker.fetchWorkersBySafetyIdRequest;
      const query = qs.stringify(request);

      const response = await workerApi.getWorkersBySafetyId(safetyId, query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * worker 상세조회
 */
export const getWorkerDetail = createAsyncThunk<ResWorkerDetail, string>(
  actions.GET_WORKER_DETAIL,
  async (id, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await workerApi.getWorkerDetail(id);
      const fileId = response.resultObject.workerFileId;
      if (fileId) {
        dispatch(getWorkerImageUrl(fileId));
      }

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * worker 이미지 경로 조회
 */
export const getWorkerImageUrl = createAsyncThunk<string, string>(
  actions.GET_WORKER_DOWNLOAD,
  async (id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await workerApi.getWorkerDownloadAPI(id);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 안전교육 이력조회 (user,worker둘다)📝
 */
export const getWorkerSafetyHistories = createAsyncThunk<
  ResWorkerSafetyHistories,
  'USER' | 'WORKER',
  { state: RootState }
>(
  actions.GET_WORKER_SAFETY_HISTORIES,
  async (type, { getState, fulfillWithValue, rejectWithValue }) => {
    let workerId = null;
    let query = null;

    const user = getState().user;
    const worker = getState().worker;

    if (type === 'USER') {
      workerId = user.userDetail.workerId;

      let request = user.fetchUserSafetyHistoriesReqeust;
      if (request.categoryId === 'ALL') {
        request = {
          ...user.fetchUserSafetyHistoriesReqeust,
          categoryId: ''
        };
      }

      query = qs.stringify(request);
    } else {
      workerId = worker.workerDetail.workerId;

      let request = worker.fetchWorkerSafetyHistoriesRequest;
      if (request.categoryId === 'ALL') {
        request = {
          ...worker.fetchWorkerSafetyHistoriesRequest,
          categoryId: ''
        };
      }

      query = qs.stringify(request);
    }

    try {
      const response = await workerApi.getWorkerSafetyHistories(workerId, query);

      return fulfillWithValue(response);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
